import { z } from 'zod';
import { PaginarSchema } from '../comum/paginacao';

/**
 * O que cada usuário FEZ, na tabela dedicada `atividades_usuario` — pedido
 * literal do dono: cada prompt, cada sessão criada, cada decisão de permissão.
 * É à parte da auditoria de propósito (decisão de 2026-09-20): a trilha de
 * auditoria registra toda mutação do sistema; esta registra a autoria do
 * trabalho, e a tela admin de atividade lê daqui.
 */
export const TipoAtividadeSchema = z.enum(['PROMPT', 'CRIACAO_SESSAO', 'DECISAO_PERMISSAO']);
export type TipoAtividade = z.infer<typeof TipoAtividadeSchema>;

export const ListarAtividadesSchema = PaginarSchema.extend({
  usuarioId: z.string().optional(),
  sessaoId: z.string().optional(),
  maquinaId: z.string().optional(),
  tipo: TipoAtividadeSchema.optional(),
  desde: z.iso.datetime().optional(),
  ate: z.iso.datetime().optional(),
});
export type ListarAtividades = z.infer<typeof ListarAtividadesSchema>;

/** Um item da resposta de `GET /admin/atividades`. */
export const AtividadeUsuarioSchema = z.object({
  id: z.string(),
  /** SEM chave estrangeira no banco: o histórico sobrevive à remoção da conta. */
  usuarioId: z.string(),
  sessaoId: z.string().nullable(),
  maquinaId: z.string().nullable(),
  tipo: TipoAtividadeSchema,
  texto: z.string().nullable(),
  detalhes: z.unknown().nullable(),
  criadoEm: z.iso.datetime(),
});
export type AtividadeUsuario = z.infer<typeof AtividadeUsuarioSchema>;
